import { render, staticRenderFns } from "./CreateAgendaItem.vue?vue&type=template&id=44cf8715&"
import script from "./CreateAgendaItem.vue?vue&type=script&lang=js&"
export * from "./CreateAgendaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports